import styled from 'styled-components';

export const TableWrap = styled.div`
  width: 100%;
  margin-bottom: 42px;
`;
